import React from 'react';
import {useNavigate} from "react-router-dom";
import {ReactComponent as CloseIcon} from '../icons/dark_close.svg';
import {Dialog} from '../dialog/Dialog';

interface PlayerInfoMessageProps {
    message: string | null;
    updateMessage: (value: string) => void;
}

export const PlayerInfoMessage = React.memo(({message, updateMessage}: PlayerInfoMessageProps) => {
    const [open, setOpen] = React.useState(false);
    const push = useNavigate();

    React.useEffect(() => {
        if (!open) {
            setOpen(!!message && message.length > 0)
        }
    }, [message])

    const handleConfirm = () => {
        setOpen(false);
        updateMessage('');
        push('/');
    };

    return (
        <Dialog isOpen={open} onClose={handleConfirm}>
            <div className={"bg-white text-black text-[16px] rounded-[8px] min-w-[300px] max-w-[600px]"}>
                <div className="flex justify-end p-[5px]">
                    <div
                        className="cursor-pointer p-[5px] h-[30px] w-[30px] rounded-[100%] hover:bg-grey flex justify-center items-center"
                        onClick={handleConfirm}
                    >
                        <CloseIcon/>
                    </div>
                </div>
                <div className="p-[27px]">
                    <span className="text-[18px]">{message}</span>
                </div>
            </div>
        </Dialog>
    );
}, (prevProps, nextProps) => prevProps.message === nextProps.message);
